import styled from 'styled-components';
import { getBaseTheme } from '@Themes';

const { colors, texts, sizes } = getBaseTheme();

export const CardWrapper = styled.div`
    border-radius: 2px;
    background-color: ${colors.area.default.backgroundColor};
    border: 1px solid ${colors.area.default.strokeColor};
    border-left: 4px ${({ color }) => color} solid;
    line-height: ${texts.sizes.default.lineHeight};
    padding: 0.8rem 1.2rem;
    margin-right: 2px;
    margin-left: 2px;

    .collapsible-panel {
        cursor: pointer;

        &__title,
        &__toggler i {
            color: rgb(17, 16, 25, 0.4);
        }

        &__title {
            font-size: ${sizes.s};
        }

        &__toggler i {
            margin: 0;
        }

        &:hover {
            .collapsible-panel__title {
                color: #000;
            }
        }
    }

    .collapsible-text {
        margin: 0;
        &.collapsed {
            position: absolute;
            opacity: 0;

            /* This is very important to be able to calc the */
            /* lineHeight for Selectable while collapsed */
            /* Refers to https://stackoverflow.com/questions/30637577/how-to-obtain-clientwidth-clientheight-before-div-is-visible */
            display: block !important;
        }
    }

    &:hover button.go-to-clause-details {
        color: #0168fe;
    }

    /* stack effect */
    box-shadow: ${({ isOpened, stackEffect }) =>
        isOpened && stackEffect
            ? '0px 0px 2px 0px rgba(0, 0, 0, 0.2), 0 6px 0 -4px #fff, 0 6px 1px -3px rgba(0, 0, 0, 0.15), 0 11px 0 -6px #fff, 0 11px 1px -5px rgba(0, 0, 0, 0.15)'
            : '0px 0px 2px 0px rgba(0, 0, 0, 0.2)'};
`;
